<div class="cmn-textarea-field">
    @if (label) {
    <label class="cmn-textarea-field__label" [for]="id">
        {{ label }}
    </label>
    }

    <textarea class="cmn-textarea-field__control" [id]="id" [name]="name" [rows]="rows" [attr.maxlength]="maxlength"
        [placeholder]="placeholder" [value]="value" [disabled]="disabled" (input)="handleInput($event)"
        (blur)="handleBlur()"></textarea>

    @if (showCharacterCount && maxlength) {
    <small class="cmn-textarea-field__count" [class.cmn-textarea-field__count--limit]="characterCount >= +maxlength">
        {{ characterCount }} / {{ maxlength }}
    </small>
    }
</div>